import type { Stasher } from '@stash/shared-types';

// TODO: wire to real friends selector once friends slice exists
export function useTopFriends(): Stasher[] {
  return [];
}
